<template>
  <div class="container">
    <template>
      <div class="addRoute">
        <div class="addBillboardPlacement__header">
          <h1 class="medium-title">{{ placementId ? `Edit Placement` : `Add New Placement` }}</h1>
        </div>
        <div v-if="!isLoadingAll" class="addBillboardPlacement__body">
          <!-- Left Content -->
          <div class="addBillboardPlacement__body__left">
            <div class="addBillboardPlacement__body__left__form">
              <div class="addBillboardPlacement__body__left__form__container">
                <div class="addBillboardPlacement__body__left__form__container__item">
                  <a-select-dropdown
                    :label="`Select Location`"
                    :options="options.locations"
                    :value.sync="model.location"
                    :error.sync="vuelidateOptions.location.error"
                    :ref="vuelidateOptions.location.ref"
                  />
                </div>
              </div>
              <div class="addBillboardPlacement__body__left__form__container">
                <h1 class="subhead">General Information</h1>
                <div class="addBillboardPlacement__body__left__form__container__item">
                  <a-input
                    :label="`Placement Name`"
                    :value.sync="model.placement"
                    :error.sync="vuelidateOptions.placement.error"
                    :ref="vuelidateOptions.placement.ref"
                  />
                </div>
                <div class="addBillboardPlacement__body__left__form__container__item">
                  <a-textarea
                    :label="`Description ( Optional )`"
                    :value.sync="model.description"
                    :error.sync="vuelidateOptions.description.error"
                    :ref="vuelidateOptions.description.ref"
                  />
                </div>
              </div>
              <div class="addBillboardPlacement__body__left__form__container">
                <h1 class="subhead">Placement Details</h1>
                <div class="addBillboardPlacement__body__left__form__container__item--flex">
                  <a-select-dropdown
                    :label="`Lighting`"
                    :options="options.lighting"
                    :value.sync="model.lighting"
                    :error.sync="vuelidateOptions.lighting.error"
                    :ref="vuelidateOptions.lighting.ref"
                  />
                  <a-select-dropdown
                    :label="`Orientation`"
                    :options="options.orientations"
                    :value.sync="model.orientation"
                    :error.sync="vuelidateOptions.orientation.error"
                    :ref="vuelidateOptions.orientation.ref"
                  />
                </div>
                <div class="addBillboardPlacement__body__left__form__container__item--flex">
                  <a-input
                    :label="`Width`"
                    :value.sync="model.width"
                    type="number"
                    :error.sync="vuelidateOptions.width.error"
                    :ref="vuelidateOptions.width.ref"
                  />
                  <a-input
                    :label="`Height`"
                    :value.sync="model.height"
                    type="number"
                    :error.sync="vuelidateOptions.height.error"
                    :ref="vuelidateOptions.height.ref"
                  />
                  <a-select-dropdown
                    :label="`Unit`"
                    :options="options.units"
                    :value.sync="model.unit"
                    :error.sync="vuelidateOptions.unit.error"
                    :ref="vuelidateOptions.unit.ref"
                  />
                </div>
                <div class="addBillboardPlacement__body__left__form__container__item--flex">
                  <a-input
                    :label="`Total Spot`"
                    :value.sync="model.totalSpot"
                    type="number"
                    :error.sync="vuelidateOptions.totalSpot.error"
                    :ref="vuelidateOptions.totalSpot.ref"
                  />
                  <a-select-dropdown
                    :label="`Position`"
                    :options="options.positions"
                    :value.sync="model.position"
                    :error.sync="vuelidateOptions.position.error"
                    :ref="vuelidateOptions.position.ref"
                  />
                </div>
                <div class="addBillboardPlacement__body__left__form__container__item--flex">
                  <a-input
                    :label="`Total Slot (Optional)`"
                    :value.sync="model.totalSlot"
                    type="number"
                    :error.sync="vuelidateOptions.totalSlot.error"
                    :ref="vuelidateOptions.totalSlot.ref"
                  />
                  <a-select-dropdown
                    :label="`Duration / Slot (Optional)`"
                    :options="options.durations"
                    :value.sync="model.duration"
                    :error.sync="vuelidateOptions.duration.error"
                    :ref="vuelidateOptions.duration.ref"
                  />
                </div>
              </div>
              <!-- Hide until decided on the meeting -->
              <!-- <div class="addBillboardPlacement__body__left__form__container">
                <h1 class="subhead">Stock Availability</h1>
                <div class="addBillboardPlacement__body__left__form__container__item--flex">
                  <a-input :label="`Quantity`" :value.sync="model.quantity" type="number"/>
                  <a-checkbox
                    :label="`Set As Unlimited`"
                    :value.sync="model.unlimited"
                    :valueLabel="`unlimited`"
                  />
                  <a-checkbox
                    :label="`Out Of Stock`"
                    :value.sync="model.outOfStock"
                    :valueLabel="`outoftock`"
                  />
                </div>
              </div>-->
              <div class="addBillboardPlacement__body__left__form__container">
                <h1 class="subhead">Item Price</h1>
                <div class="addBillboardPlacement__body__left__form__container__item--flex">
                  <a-input
                    :label="`Public Price`"
                    :value.sync="model.publicPrice"
                    frontIcon="rupiah"
                    :error.sync="vuelidateOptions.publicPrice.error"
                    :ref="vuelidateOptions.publicPrice.ref"
                    type="number"
                  />
                  <a-input
                    :label="`Bottom Price`"
                    :value.sync="model.bottomPrice"
                    frontIcon="rupiah"
                    :error.sync="vuelidateOptions.bottomPrice.error"
                    :ref="vuelidateOptions.bottomPrice.ref"
                    type="number"
                  />
                </div>
              </div>
              <div class="addBillboardPlacement__body__left__form__container">
                <h1 class="subhead">Future Price (Optional)</h1>
                <div
                  class="addBillboardPlacement__body__left__form__container__item--flex--90"
                  v-for="(futurePrice, index) in model.futurePrices"
                  :key="index"
                >
                  <div class="addBillboardPlacement__body__left__form__container__item--no-margin">
                    <div
                      :class="[(vuelidateOptions.futurePrices.error[index].startDate) || (vuelidateOptions.futurePrices.error[index].endDate ) ? 'calendarWrapperWarning' : 'calendarWrapper']"
                      :ref="vuelidateOptions.futurePrices.ref.startDate"
                    >
                      <div class="singleCalendar" :ref="vuelidateOptions.futurePrices.ref.endDate">
                        <h6 class="small-font color-grey">Future Start Date</h6>
                        <v-date-picker
                          v-model="futurePrice.startDate"
                          class="date-input"
                          :theme-styles="themeStyles"
                          :popoverVisibility="'focus'"
                        >
                          <input
                            class="calendar-start"
                            type="text"
                            slot-scope="{ inputValue, updateValue }"
                            disabled
                            :value="inputValue"
                            @input="updateValue($event.target.value, { formatInput: false, hidePopover: false })"
                            @popover-did-appear="toggleBorder"
                            @popover-did-disappear="toggleBorder"
                            @change="updateValue($event.target.value, { formatInput: true, hidePopover: false })"
                          />
                        </v-date-picker>
                      </div>
                      <div class="divider">
                        <i class="icon-arrow-forward"></i>
                      </div>
                      <div class="singleCalendar">
                        <h6 class="small-font color-grey">Future End Date</h6>
                        <v-date-picker
                          v-model="futurePrice.endDate"
                          class="date-input"
                          :theme-styles="themeStyles"
                          :popoverVisibility="'focus'"
                        >
                          <input
                            class="calendar-start"
                            type="text"
                            slot-scope="{ inputValue, updateValue }"
                            disabled
                            :value="inputValue"
                            @input="updateValue($event.target.value, { formatInput: false, hidePopover: false })"
                            @popover-did-appear="toggleBorder"
                            @popover-did-disappear="toggleBorder"
                            @change="updateValue($event.target.value, { formatInput: true, hidePopover: false })"
                          />
                        </v-date-picker>
                      </div>
                    </div>
                    <div
                      v-if="vuelidateOptions.futurePrices.error[index].startDate || vuelidateOptions.futurePrices.error[index].endDate"
                      class="error-message"
                    >{{vuelidateOptions.futurePrices.error[index].startDate || vuelidateOptions.futurePrices.error[index].endDate}}</div>
                    <div class="addBillboardPlacement__body__left__form__container__item--flex">
                      <a-input
                        frontIcon="rupiah"
                        :label="`Future Public Price`"
                        :value.sync="futurePrice.futurePublicPrice"
                        :error.sync="vuelidateOptions.futurePrices.error[index].futurePublicPrice"
                        :ref="vuelidateOptions.futurePrices.ref.futurePublicPrice"
                        type="number"
                      />
                      <a-input
                        frontIcon="rupiah"
                        :label="`Future Bottom Price`"
                        :value.sync="futurePrice.futureBottomPrice"
                        :error.sync="vuelidateOptions.futurePrices.error[index].futureBottomPrice"
                        :ref="vuelidateOptions.futurePrices.ref.futureBottomPrice"
                        type="number"
                      />
                    </div>
                  </div>
                  <div
                    class="addBillboardPlacement__body__left__form__container__item--padding-top"
                  >
                    <i class="icon-deleted trash" @click="deleteFuturePrice(index)"></i>
                  </div>
                </div>
                <div class="line-wrapper">
                  <hr class="line" />
                </div>
                <div class="button">
                  <button @click="addFuturePrice()" class="new">Add new</button>
                </div>
              </div>
              <!-- Purchase Restriction -->
              <div class="addBillboardPlacement__body__left__form__container">
                <h1 class="subhead">Purchase Restriction</h1>
                <div class="addBillboardPlacement__body__left__form__container__item--flex">
                  <a-input :label="`Minimum Period`" :value.sync="model.minPeriod" type="number" :error.sync="vuelidateOptions.minPeriod.error"
                    :ref="vuelidateOptions.minPeriod.ref"/>
                  <a-select-dropdown
                    :options="options.periodPlans"
                    :value.sync="model.periodPlan"
                    :error.sync="vuelidateOptions.periodPlan.error"
                    :ref="vuelidateOptions.periodPlan.ref"
                  />
                </div>
                <div class="addBillboardPlacement__body__left__form__container__item--flex">
                  <a-input
                    :label="`Lead Time`"
                    :value.sync="model.leadTime"
                    :error.sync="vuelidateOptions.leadTime.error"
                    :ref="vuelidateOptions.leadTime.ref"
                    icon="day"
                    type="number"
                  />
                </div>
              </div>
              <!-- Images -->
              <div class="addBillboardPlacement__body__left__form__container">
                <h1 class="subhead">Images</h1>
                <div
                  v-for="(image, index) in model.images"
                  :key="index"
                  class="addBillboardPlacement__body__left__form__container__images__image"
                >
                  <div class="upload-wrapper">
                    <div class="top">
                      <div class="upload-button">
                        <input
                          type="file"
                          accept="image/*"
                          @change="getFileImage($event, image, index)"
                          :name="`fileUpload`+index"
                          :id="`fileUpload`+index"
                          style="display: none;"
                        />
                        <label :for="`fileUpload`+index" class="button-input">Add Image</label>
                      </div>
                      <div v-if="image.url" class="file-image">
                        <img :src="image.url" />
                      </div>
                      <div class="file-name">
                        <span class="image_name">
                          <label>{{image.name}}</label>
                          <i v-if="image.name" @click="cancelImage(index)" class="adx-ic_cancel"></i>
                        </span>
                        <div class="image_status" v-if="imageLoadings[index] != null">
                          <span v-if="imageLoadings[index]" class="is_loading">Loading...</span>
                          <span
                            v-if="!imageLoadings[index] && image.isSuccess"
                            class="is_success"
                          >Uploaded</span>
                          <span
                            v-if="!imageLoadings[index] && !image.isSuccess"
                            class="is_error"
                          >Error</span>
                        </div>
                      </div>
                    </div>
                    <div class="bottom">
                      <div>
                        <a-checkbox
                          :label="`Set as featured image`"
                          :valueLabel.sync="image.isFeatured"
                          :value.sync="image.isFeatured"
                          :inputId="index"
                          @buttonClicked="buttonClicked(image)"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="icon-wrapper">
                    <i @click="deleteImages(model.images, index)" class="icon-deleted"></i>
                  </div>
                </div>
                <div class="line-wrapper">
                  <hr class="line" />
                </div>
                <div class="button">
                  <button @click="addImage(model.images)" class="new">Add new</button>
                </div>
              </div>
            </div>
          </div>
          <!-- Right Content -->
          <div class="addBillboardPlacement__body__right">
            <div class="addBillboardPlacement__body__right__status__container">
              <h1 class="subhead">Tags ( Optional )</h1>
              <div class="addBillboardPlacement__body__right__tags">
                <adx-input-tag
                  :limit="tagLimit"
                  v-model="model.tagsText"
                  :value="model.tagsText"
                  placeholder="Separate tags with comma"
                  :add-tag-on-blur="false"
                  :key="tagKey"
                />
              </div>
            </div>
            <div class="button">
              <button class="btn-large primary" @click="save">
                Save
                <a-loading-scnd-white v-if="saveLoading" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="isLoadingAll">
      <div class="container__loadingWrapper">
        <slot name="loading" />
        <a-loading />
      </div>
    </template>
  </div>
</template>	

<script>
import InputTag from "@/components/Form/InputTag";
import * as validationLib from "@/lib/validation/";
import triggerValidation from "@/lib/triggerValidation";
import { mapListFilter, fromArrayKeys } from "@/lib/transformer";
import { globalMixins } from "@/lib/mixins/globalMixins";
import { mapGetters } from "vuex";
import { restEdge } from "@/api/edgeUrls";
import api from "@/api";
import {
  required,
  minLength,
  maxLength,
  alphaNum,
  alpha,
  requiredIf
} from "vuelidate/lib/validators";
import {
  AInput,
  ACheckbox,
  ATextArea,
  ASelectDropdown,
  ASingleSearchDropdown,
  ALoadingPrimary,
  ALoadingSecondary,
  ALoadingSecondaryWhite,
  AEmptySelection,
  AModal
} from "ui-kit-v1";

const { helpers, validate } = validationLib;
import calendar from "v-calendar";

export default {
  name: "adx-add-route",
  components: {
    "adx-input-tag": InputTag,
    "a-modal": AModal,
    "a-loading": ALoadingPrimary,
    "a-loading-scnd-white": ALoadingSecondaryWhite,
    "a-empty-selection": AEmptySelection,
    "a-input": AInput,
    "a-checkbox": ACheckbox,
    "a-textarea": ATextArea,
    "a-select-dropdown": ASelectDropdown,
    "a-single-search-dropdown": ASingleSearchDropdown,
    "v-calendar": calendar
  },
  mixins: [globalMixins],
  props: {},
  data() {
    return {
      tagKey: false,
      tagLimit: 100,
      startDate: new Date(),
      endDate: new Date(),
      themeStyles: {
        dayContent: {
          fontSize: "15px"
        },
        headerTitle: {
          fontSize: "17px",
          fontWeight: "bold"
        },
        weeks: {
          fontWeight: "bold"
        },
        wrapper: {
          boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.16)",
          backgroundColor: "white",
          border: "none"
        },
        header: {
          marginBottom: "6px"
        }
      },
      isLoadingAll: false,
      saveLoading: false,
      size: "small",
      imageLoadings: [],
      placementId: null,
      model: {
        location: null,
        placement: null,
        description: null,
        lighting: null,
        orientation: null,
        width: null,
        height: null,
        unit: null,
        totalSpot: null,
        position: null,
        totalSlot: null,
        duration: null,
        quantity: null,
        unlimited: null,
        outOfStock: null,
        publicPrice: null,
        bottomPrice: null,
        periodPlan: null,
        leadTime: null,
        tagsText: [],
        futurePrices: [
          {
            startDate: null,
            endDate: null,
            futurePublicPrice: null,
            futureBottomPrice: null
          }
        ],
        imageIds: [],
        images: [
          {
            id: null,
            name: null,
            image: null,
            isFeatured: null,
            url: null
          }
        ]
      },
      vuelidateOptions: {
        location: {
          error: null,
          ref: "location"
        },
        placement: {
          error: null,
          ref: "placement"
        },
        description: {
          error: null,
          ref: "description"
        },
        lighting: {
          error: null,
          ref: "lighting"
        },
        orientation: {
          error: null,
          ref: "orientation"
        },
        width: {
          error: null,
          ref: "width"
        },
        height: {
          error: null,
          ref: "height"
        },
        unit: {
          error: null,
          ref: "unit"
        },
        totalSpot: {
          field: "total spot",
          error: null,
          ref: "totalSpot"
        },
        position: {
          error: null,
          ref: "position"
        },
        totalSlot: {
          field: "total slot",
          error: null,
          ref: "totalSlot"
        },
        duration: {
          error: null,
          ref: "duration"
        },
        publicPrice: {
          field: "public price",
          error: null,
          ref: "publicPrice"
        },
        bottomPrice: {
          field: "bottom price",
          error: null,
          ref: "bottomPrice"
        },
        futurePrices: {
          field: {
            startDate: "start date",
            endDate: "end date",
            futurePublicPrice: "public price",
            futureBottomPrice: "bottom price"
          },
          error: [
            {
              startDate: null,
              endDate: null,
              futurePublicPrice: null,
              futureBottomPrice: null
            }
          ],
          ref: {
            startDate: "startDate",
            endDate: "endDate",
            futurePublicPrice: "futurePublicPrice",
            futureBottomPrice: "futureBottomPrice"
          }
        },
        minPeriod: {
          field: "minimum period",
          error: null,
          ref: "minPeriod"
        },
        periodPlan: {
          field: "period plan",
          error: null,
          ref: "periodPlan"
        },
        leadTime: {
          field: "lead time",
          error: null,
          ref: "leadTime"
        },
      },
      options: {
        locations: [],
        users: [],
        orientations: [
          {
            value: "vertical",
            label: "Vertical"
          },
          {
            value: "horizontal",
            label: "Horizontal"
          }
        ],
        lighting: [
          {
            value: "backlight",
            label: "Back Light"
          },
          {
            value: "frontlight",
            label: "Front Light"
          },
          {
            value: "LED",
            label: "LED"
          }
        ],
        units: [
          {
            value: "centimeters",
            label: "Centimeters"
          },
          {
            value: "meters",
            label: "Meters"
          }
        ],
        positions: [
          {
            value: "Stand Alone",
            label: "Stand Alone"
          },
          {
            value: "Bridge",
            label: "Bridge"
          },
          {
            value: "Stick to Building",
            label: "Stick to Building"
          }
        ],
        durations: [
          {
            value: 10,
            label: "10 Seconds"
          },
          {
            value: 15,
            label: "15 Seconds"
          },
          {
            value: 30,
            label: "30 Seconds"
          }
        ],
        periodPlans: [
          {
            value: "day",
            label: "Day"
          },
          {
            value: "week",
            label: "Week"
          },
          {
            value: "month",
            label: "Month"
          },
          {
            value: "quarter",
            label: "Quarter"
          },
          {
            value: "year",
            label: "Year"
          }
        ]
      }
    };
  },
  validations: {
    model: {
      location: { required },
      placement: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(100)
      },
      description: { minLength: minLength(1), maxLength: maxLength(255) },
      lighting: { required },
      orientation: { required },
      width: { required, minLength: minLength(1), maxLength: maxLength(5) },
      height: { required, minLength: minLength(1), maxLength: maxLength(5) },
      unit: { required },
      totalSpot: { required, minLength: minLength(1), maxLength: maxLength(5) },
      position: { required },
      totalSlot: {
        required: requiredIf(obj => obj.duration),
        minLength: minLength(1),
        maxLength: maxLength(5)
      },
      duration: { required: requiredIf(obj => obj.totalSlot) },
      publicPrice: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(15)
      },
      bottomPrice: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(15)
      },
      futurePrices: {
        $each: {
          startDate: {
            requiredIf: requiredIf(
              obj =>
                obj.endDate != null ||
                obj.futurePublicPrice != null ||
                obj.futureBottomPrice != null
            )
          },
          endDate: {
            requiredIf: requiredIf(
              obj =>
                obj.startDate != null ||
                obj.futurePublicPrice != null ||
                obj.futureBottomPrice != null
            )
          },
          futurePublicPrice: {
            requiredIf: requiredIf(
              obj =>
                obj.endDate != null ||
                obj.startDate != null ||
                obj.futureBottomPrice != null
            )
          },
          futureBottomPrice: {
            requiredIf: requiredIf(
              obj =>
                obj.endDate != null ||
                obj.futurePublicPrice != null ||
                obj.startDate != null
            )
          }
        }
      },
      minPeriod: { required, minLength: minLength(1), maxLength: maxLength(3) }, 
      periodPlan: { required },
      leadTime: { required, minLength: minLength(1), maxLength: maxLength(5) },
    }
  },
  computed: {
    ...mapGetters({
      user: "account",
      token: "token"
    })
  },
  apollo: {},
  watch: {},
  beforeCreate() {},
  async created() {
    if (this.$route.params.hasOwnProperty("id"))
      this.placementId = this.$route.params.id;

    await this.getFormOptions();
    if (this.placementId) await this.getFormData();
  },
  beforeMount() {},
  async mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    cancelFile() {
      this.model.kmlFileName = null;
      this.kmlLoading = null;
    },
    launchFilePicker() {
      this.$refs.fileUpload.click();
    },
    getFileImage(event, image, index) {
      let input = event.target;
      if (input.files && input.files[0]) {
        let reader = new FileReader();
        let validated_data = this.validateImageFile(input.files[0]);
        if (!validated_data.is_valid) {
          this.showNotificationAlert("Error", validated_data.message, "danger");
        } else {
          reader.onload = e => {
            image.url = e.target.result;
          };
          reader.readAsDataURL(input.files[0]);
          image.name = input.files[0].name;
          image.image = input.files[0];
          this.saveImage(input.files[0], image, index);
        }
      }
    },
    async saveImage(fileData, image, index) {
      image.loading = true;
      this.$set(this.imageLoadings, index, true);
      let formData = new FormData();
      formData.append("file", fileData);
      formData.append("name", fileData.name);
      const result = await api.post(restEdge.uploadBillboardContent, formData, {
        needToken: true,
        useRestEdge: true,
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
      await this.$nextTick();
      this.$set(this.imageLoadings, index, false);
      if (!result.errors) {
        image.isSuccess = true;
        image.id = parseInt(result.data.id);
        this.model.images[index] = result.data;
        this.model.images[index].isSuccess = true;
        this.model.images[index].loading = true;
        this.model.imageIds.push({ id: parseInt(result.data.id) });
      } else {
        image.isSuccess = false;
      }
    },
    cancelImage(index) {
      this.model.images[index].id = null;
      this.model.images[index].name = null;
      this.model.images[index].image = null;
      this.model.images[index].isFeatured = null;
      this.model.images[index].url = null;
      this.$set(this.imageLoadings, index, null);
    },
    validateImageFile(file) {
      let maxSize = 2000000; // 2 MB
      let data = { is_valid: true };
      if (/image/.test(file.type)) {
        let image_ext_patt = new RegExp(/.jpg|.jpeg|.png/);
        if (!image_ext_patt.test(file.name.toLowerCase())) {
          data.is_valid = false;
          data.message = "Unsupported file type";
          return data;
        }
      } else {
        data.is_valid = false;
        data.message = "Unsupported file type";
        return data;
      }
      if (file.size > maxSize) {
        data.is_valid = false;
        data.message = `File too large.`;
        return data;
      }
      const filename = file.name.split(".")[0];
      if (filename.length > 100) {
        data.is_valid = false;
        data.message = "File name is too long. Maximum size 100 character";
        return data;
      }

      if (filename.includes("/")) {
        data.is_valid = false;
        data.message = "File name has forbidden character";
        return data;
      }
      return data;
    },
    addImage(images) {
      images.push({
        id: null,
        name: null,
        image: null,
        isFeaturedurl: null
      });
    },
    addFuturePrice() {
      this.model.futurePrices.push({
        startDate: null,
        endDate: null,
        futurePublicPrice: null,
        futureBottomPrice: null
      });

      this.vuelidateOptions.futurePrices.error.push({
        startDate: null,
        endDate: null,
        futurePublicPrice: null,
        futureBottomPrice: null
      });
    },
    deleteFuturePrice(index) {
      if (this.model.futurePrices.length > 1) {
        this.model.futurePrices.splice(index, 1);
      } else {
        this.showNotificationAlert(
          "Delete Error",
          "Oops data can not be deleted!",
          "danger"
        );
      }
    },
    deleteImages(image, index) {
      image.splice(index, 1);
      this.imageLoadings.splice(index, 1);
    },
    async save() {
      this.clearFuturePriceError()
      this.$v.$touch();

      if (this.$v.model.$invalid) {
        const {
          key,
          message,
          element,
          collection
        } = helpers.vuelidateValidationHelper(
          this.$v.model,
          this.vuelidateOptions,
          this.$refs
        );
        if (collection) {
          this.vuelidateOptions[key].error[collection.index][
            collection.collectionKey
          ] = message;
        } else {
          this.vuelidateOptions[key].error = message;
        }
        if (typeof element[0] == "undefined") {
          this.$nextTick(function() {
            element.scrollIntoView();
          });
        } else {
          this.$nextTick(function() {
            if (element[0].hasOwnProperty("$el")) {
              element[0].$el.scrollIntoView();
            } else {
              element[0].scrollIntoView();
            }
          });
        }
      } else {
        this.saveLoading = true;

        const FP = this.model.futurePrices.map(futurePrice => {
          return {
            start: futurePrice.startDate,
            end: futurePrice.endDate,
            publicPrice: parseInt(futurePrice.futurePublicPrice),
            bottomPrice: parseInt(futurePrice.futureBottomPrice),
            billboardPlacementId: this.model.location
          };
        });

        const CONTENT = this.model.images.map(c => {
          return {
            id: c.createdAt ? undefined : c.id,
            isFeatured: c.isFeatured,
            caption: c.name || c.caption,
            imageUrl: c.imageUrl,
            isPrimary: c.isFeatured,
            is360: c.is360
          };
        });

        const data = {
          billboardLocationId: this.model.location,
          name: this.model.placement,
          description: this.model.description,
          lighting: this.model.lighting,
          orientation: this.model.orientation,
          width: parseInt(this.model.width),
          height: parseInt(this.model.height),
          unit: this.model.unit,
          totalSpot: parseInt(this.model.totalSpot),
          position: this.model.position,
          totalSlot: parseInt(this.model.totalSlot),
          duration: this.model.duration,
          stock: 1,
          unlimited: false,
          outOfStock: false,
          publicPrice: parseInt(this.model.publicPrice),
          bottomPrice: parseInt(this.model.bottomPrice),
          billboardFuturePrice: FP,
          minPeriod: parseInt(this.model.minPeriod),
          minPeriodPlan: this.model.periodPlan,
          minQuantity: 1,
          leadTime: parseInt(this.model.leadTime),
          billboardContent: CONTENT,
          tags: this.model.tagsText
        };

        let response;

        if (this.placementId) {
          response = api.put(
            restEdge.editBillboardPlacement(this.placementId),
            data,
            {
              needToken: true,
              useRestEdge: true
            }
          );
        } else {
          response = api.post(restEdge.createBillboardPlacement, data, {
            needToken: true,
            useRestEdge: true
          });
        }

        this.saveLoading = false;
        response.then(({ status }) => {
          if (status === 200) {
            this.showNotificationAlert(
              "Success",
              "Data successfully saved!",
              "success"
            );
            this.$router.push({ name: "billboardplacement" });
          } else {
            this.showNotificationAlert("Error", "Data failed to save", "danger");
          }
        });
      } 
    },
    async getFormOptions() {
      const { data, status, statusText } = await api.get(
        restEdge.getFormBillboardPlacementdata,
        {
          needToken: true,
          useRestEdge: true
        }
      );

      if (status === 200) {
        this.options.locations = await data.locations.map(location => ({
          id: location.id,
          label: location.name,
          title: location.name,
          value: location.id
        }));
        this.options.users = await data.emails.map(user => ({
          id: parseInt(user.id),
          label: user.email,
          title: user.email,
          value: user.id
        }));
      } else {
        this.showNotificationAlert("Error", statusText, "danger");
      }
    },
    async getFormData() {
      const { data, status, statusText } = await api.get(
        restEdge.getBillboardPlacementById(this.placementId),
        {
          needToken: true,
          useRestEdge: true
        }
      );

      if (status === 200) {
        this.model.location = data.billboardLocationId;
        this.model.placement = data.name;
        this.model.description = data.description;
        this.model.lighting = data.lighting;
        this.model.orientation = data.orientation;
        this.model.width = data.width;
        this.model.height = data.height;
        this.model.unit = data.unit;
        this.model.totalSpot = data.totalSpot;
        this.model.position = data.position;
        this.model.totalSlot = data.totalSlot;
        this.model.duration = data.duration;
        this.model.publicPrice = data.publicPrice;
        this.model.bottomPrice = data.bottomPrice;
        this.model.futurePrices = data.billboardFuturePrice.length ? data.billboardFuturePrice.map(x => {
          this.vuelidateOptions.futurePrices.error.push({
            startDate: null,
            endDate: null,
            futurePublicPrice: null,
            futureBottomPrice: null
          });
          return {
            startDate: new Date(x.start),
            endDate: new Date(x.end),
            futureBottomPrice: x.bottomPrice,
            futurePublicPrice: x.publicPrice
          };
        }) : [{ startDate: null, endDate: null, futurePublicPrice: null, futureBottomPrice: null }]
        this.model.minPeriod = data.minPeriod;
        this.model.periodPlan = data.minPeriodPlan;
        this.model.leadTime = data.leadTime;
        this.model.images = data.billboardContent.length ? data.billboardContent.map(x => {
          return {
            id: x.id,
            isFeatured: x.isFeatured,
            name: x.caption,
            url: x.imageUrl,
            createdAt: x.createdAt
          };
        }) : [{ id: null, name: null, image: null, isFeatured: null, url: null }]
        this.model.tagsText = data.tags.map(x => x.name);
        this.tagKey = !this.tagKey
      } else {
        this.showNotificationAlert("Error", statusText, "danger");
      }
    },
    buttonClicked(image) {
      this.model.images.map(img => {
        if (img.id !== image.id) img.isFeatured = false;
      });
    },
    toggleBorder() {
      this.isBorder = !this.isBorder;
    },
    clearFuturePriceError() {
      let errors = this.vuelidateOptions.futurePrices.error.map(futurePrice => ({ startDate: null, endDate: null, futurePublicPrice: null, futureBottomPrice: null }))
      this.vuelidateOptions.futurePrices.error = errors
    }
  }
};
</script>

<style lang='scss' scoped>
@import "./index.scss";
@import "~@/styles/variables";
@import "~@/styles/mixins";
</style>

<style lang="scss">
@import "~@/styles/variables";
@import "~@/styles/mixins";

  .addBillboardPlacement {
    &__body {
      &__left {
        &__form {
          &__container {
            .rupiah::before {
              margin-right: 0 !important;
            }

            .selectDropdown {
              input {
                padding-top: 0;
              }
  
              .popup {
                max-height: 300px;
                overflow-y: auto;

                &__input {
                  max-width: 100%;
                  margin-left: 48px;
                }
              }
            }
          }
        }
      }

      &__right {
        &__tags {
          .new-tag{
            margin-top: 0 !important;
          }

          .input-tag {
            max-height: 32px;
          }
        }
      }
    }

    .waypointWrapper {
      display: flex;
    }

    .btn-regular {
      min-width: 32px;
      height: 45px;

      &.teal {
        background-color: $white;
        border: solid 1px $pale-grey;
        color: unset;
      }
    }

    .title.large-font {
      font-size: 24px;
    }
  }
</style>
